var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from "@ngrx/store";
import * as Actions from "../actions/index";
var DEFAULT_STATE = {
    loading: false,
    payload: null,
    results: null,
    error: null
};
export function reducer(state, action) {
    if (state === void 0) { state = DEFAULT_STATE; }
    switch (action.type) {
        case Actions.REQUEST_BULK_RESET:
            return __assign({}, DEFAULT_STATE);
        case Actions.Customers.REQUEST_BULK_ADD_CUSTOMERS:
        case Actions.Staff.REQUEST_BULK_IMPORT: {
            return __assign({}, state, { payload: action.payload, loading: true, error: null });
        }
        case Actions.Customers.PROGRESS_BULK_ADD_CUSTOMERS:
            return __assign({}, state, { progress: action.payload });
        case Actions.Customers.RESPONSE_FAIL_BULK_ADD_CUSTOMERS:
        case Actions.Staff.RESPONSE_FAIL_BULK_IMPORT:
            return __assign({}, state, { error: action.payload, loading: false });
        case Actions.Customers.RESPONSE_SUCCESS_BULK_ADD_CUSTOMERS:
        case Actions.Staff.RESPONSE_SUCCESS_BULK_IMPORT:
            return __assign({}, state, { results: action.payload, loading: false, error: null });
        default:
            return state;
    }
}
export var getLoading = function (state) { return state.loading; };
export var getResults = function (state) { return state.results; };
export var getError = function (state) { return state.results; };
export var getProgress = function (state) { return state.progress; };
export var createSelectors = function (rootReducer) { return ({
    getLoading: createSelector(rootReducer, getLoading),
    getResults: createSelector(rootReducer, getResults),
    getError: createSelector(rootReducer, getError),
    getProgress: createSelector(rootReducer, getProgress)
}); };
